module.exports = __webpack_public_path__ + "img/logo.d37cb80f.png";